import React from 'react'
import PropTypes from 'prop-types'
import CloseIcon from '@material-ui/icons/Close'
import { Chip } from '@material-ui/core'

const ChipAppliedFilter = ({ key, label, onDelete }) => {
  return (
    <Chip
      key={key}
      label={label}
      onDelete={onDelete}
      className="bg-indigo-700 focus:bg-indigo-800 rounded-full text-sm font-semibold text-white min-w-min whitespace-nowrap group"
      deleteIcon={
        <CloseIcon className="text-white rounded-full hover:bg-white hover:text-indigo-700 group-focus:bg-yellow-500 group-focus:text-indigo-700" />
      }
    />
  )
}

export default ChipAppliedFilter

ChipAppliedFilter.propTypes = {
  key: PropTypes.string,
  onDelete: PropTypes.func,
  label: PropTypes.string.isRequired
}
